import React from 'react';
import { PenLine, Paperclip, Send, Clock } from 'lucide-react';
import { Card } from '@/components/ui/card';

const Metric = ({ label, value, testId }) => (
  <div className="rounded-lg bg-white border border-emerald-100 px-2 py-2 text-center min-w-0" data-testid={testId}><p className="text-lg font-bold text-slate-900 leading-tight">{value}</p><p className="text-[11px] text-slate-500 break-words leading-tight">{label}</p></div>
);

export const WriterAgentCard = ({ prospects, bulk, t }) => {
  const n = (f) => prospects.filter(f).length;
  return (
    <Card className="p-4 sm:p-5 min-w-0 border-emerald-200 bg-gradient-to-br from-emerald-50/70 to-white flex flex-col" data-testid="agent-writer-card">
      <div className="flex items-start gap-3 mb-3">
        <div className="h-10 w-10 rounded-xl bg-emerald-600 text-white flex items-center justify-center flex-none"><PenLine className="h-5 w-5" /></div>
        <div><p className="font-bold text-slate-900">{t('prospects.agents.writerTitle')}</p><p className="text-xs text-slate-600">{t('prospects.agents.writerDesc')}</p></div>
      </div>
      <div className="grid grid-cols-3 sm:grid-cols-5 gap-2 mb-3">
        <Metric label={t('prospects.agents.mToContact')} value={n((p) => p.status === 'to_contact')} testId="writer-m-to-contact" />
        <Metric label={t('prospects.agents.mEmailed')} value={prospects.reduce((a, p) => a + (p.emails_sent || 0), 0)} testId="writer-m-emailed" />
        <Metric label={t('prospects.agents.mFollowups')} value={n((p) => p.followup_sent_at)} testId="writer-m-followups" />
        <Metric label={t('prospects.agents.mReplies')} value={n((p) => p.replied_at)} testId="writer-m-replies" />
        <Metric label={t('prospects.agents.mInTalks')} value={n((p) => p.status === 'in_talks')} testId="writer-m-in-talks" />
      </div>
      <ul className="text-[11px] text-slate-600 flex flex-wrap gap-x-4 gap-y-1 mb-3">
        <li className="inline-flex items-center gap-1"><PenLine className="h-3 w-3 text-emerald-600" />PT-PT · adaptado ao sector</li>
        <li className="inline-flex items-center gap-1"><Paperclip className="h-3 w-3 text-emerald-600" />PDF Programa Pioneiro</li>
        <li className="inline-flex items-center gap-1"><Send className="h-3 w-3 text-emerald-600" />1 clique ou lote</li>
        <li className="inline-flex items-center gap-1"><Clock className="h-3 w-3 text-emerald-600" />Seguimento J+7</li>
      </ul>
      <div className="flex flex-wrap gap-2 mt-auto">{bulk.buttons}</div>
      <div className="mt-3 [&>*]:mb-0 [&>*+*]:mt-3">{bulk.jobCard}</div>
    </Card>
  );
};
